// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3kJXb","right":"Footer_right__21SVg","buttons":"Footer_buttons__1_1Ry"};